import React from "react";
import { Box, Container, Typography } from "@mui/material";

const HorizontalImageCarousel = (props) => {
  const {images, title} = props


  

  return (
    <Container maxWidth="xl" sx={{ overflow: "hidden", py: 4 }}>
      <Typography
        variant="h3"
        fontWeight="bold"
        gutterBottom
        align="left"
        sx={{ mb: 2 }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          width: "max-content",
          animation: "scroll 40s linear infinite", // 👈 infinite animation
          "@keyframes scroll": {
            "0%": { transform: "translateX(0)" },
            "100%": { transform: "translateX(-50%)" }, // shift half (because duplicated)
          },
        }}
      >
        {images.map((url, index) => (
          <Box
            key={index}
            sx={{
              flex: "0 0 auto",
              width: "333px",
              aspectRatio: "2 / 3",
              overflow: "hidden",
              boxShadow: 3,
              borderRadius: 2,
              backgroundColor: "#eee",
            }}
          >
            <img
              src={url}
              alt={`img-${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </Box>
        ))}
      </Box>
    </Container>
  );
}; 

export default HorizontalImageCarousel;
